import { apiClient } from '../../../../lib/api-client';
import { AnnouncementDocumentResult } from '../type/AnnouncementDocumentResult';

export async function apiGetAnnouncementDocument(documentID: number): Promise<AnnouncementDocumentResult> {
	try {
		return await apiClient.get("announcement/document",
			{
				params: { documentID: documentID }
			});
	} catch (error: any) {
		return {
			isSuccess: false,
			errorMessage: error,
			fileName: undefined,
			documentUrl: undefined,
			mimeType: undefined
		};
	}
};
